var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2402_4270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.8125C5.37512 0.8125 4.2755 1.14607 3.3402 1.77102C2.40489 2.39596 1.67591 3.28424 1.24544 4.32349C0.814965 5.36274 0.702333 6.5063 0.921786 7.60955C1.14124 8.71286 1.68292 9.72627 2.47833 10.5217C3.27375 11.3171 4.28716 11.8587 5.39043 12.0782C6.4937 12.2977 7.63724 12.185 8.67653 11.7545C9.71575 11.3241 10.604 10.5951 11.229 9.65978C11.8539 8.72449 12.1875 7.62489 12.1875 6.5C12.1875 4.99158 11.5883 3.54494 10.5217 2.47833C9.45503 1.41172 8.00839 0.8125 6.5 0.8125ZM5.6875 8.7709L3.65625 6.73965L4.30219 6.09375L5.6875 7.47909L8.69785 4.46875L9.34622 5.11306L5.6875 8.7709Z",
    fill: "#00123A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2402_4270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyCheckMark);
export default __webpack_public_path__ + "static/media/CurrencyCheckMark.1485eb4f2a9ef373ffcf2be0c799a2a7.svg";
export { ForwardRef as ReactComponent };